module.exports = __webpack_public_path__ + "img/project-6.3468fc79.jpg";